import React from 'react'
import PropTypes from 'prop-types'
import './CarouselCard.scss'

const CarouselCard = props => {
  return (
    <div
      className='CarouselCard'
      style={{ marginRight: props.margin }}
      data-ratio-idx={props.ratioIdx}
    >
      <div className='CarouselCard__content'>{props.children}</div>
    </div>
  )
}

CarouselCard.propTypes = {
  children: PropTypes.node,
  ratioIdx: PropTypes.number,
  margin: PropTypes.number
}
export default CarouselCard
